module.exports = __webpack_public_path__ + "static/media/7.0066c153.png";